import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'

const dictionary = {
  ja: {
    messages: {
      numeric: (field) =>`${field}は半角数字のみ使用できます`
    }
  }
}

Validator.localize('ja', ja)

Vue.use(VeeValidate, {
  locale: ja,
  dictionary
})